import React from "react"

import Section from "@components/section"
// import Bottom from "./superSmashBros_bottom"

const Zh = () => {
  return (
    <>
      <Section title="比赛信息">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>比赛时间（直播）</td>
              <td>
                10月17日（周六） 13:00 - 14:30 A组双败淘汰赛 <br />
                10月17日（周六） 14:30 - 16:00 B组双败淘汰赛 <br />
                10月18日（周日） 13:00 - 14:30 C组双败淘汰赛 <br />
                10月18日（周日） 14:30 - 16:00 D组双败淘汰赛 <br />
                10月24日（周六） 13: 00 开始 八强 决赛
                <br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  前往虎牙直播间：660161
                </a>
              </td>
            </tr>
            <tr>
              <td>模式</td>
              <td>线上赛</td>
            </tr>
            <tr>
              <td>赛制</td>
              <td>双败淘汰赛</td>
            </tr>
            <tr>
              <td>比赛规则</td>
              <td>
                本次比赛限定Steam平台参赛。
                <br />
                前期对局采用BO3，8强部分采用BO5。限时99秒，每局抢2。
                <br />
                前一局的胜者不可更换角色，但可以先于对手调整V-Trigger和V-Skill。
                <br />
                不可选择的服装和配色参见底部表格
              </td>
            </tr>
            <tr>
              <td>比赛地图</td>
              <td>
                除以下地图均可选择： <br />
                神月海滩；弗拉明戈酒馆； 名誉天空； <br />
                命运之界；神秘洞窟。
              </td>
            </tr>
            <tr>
              <td>游戏版本</td>
              <td>比赛日更新的最新版本</td>
            </tr>
            <tr>
              <td>S3赛季奖金</td>
              <td>
                冠军 4000
                <br />
                亚军 2000
                <br />
                季军 1000
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="比赛须知">
        <div className="tips">
          <p>
            1.
            不可使用WiFi环境下的设备进行比赛，为保证比赛稳定，选手需使用有线网络。{" "}
          </p>
          <p>
            2.
            报名截止后，将由机核方统一安排赛程抽签，抽签过程为保证公平性，将会发放到选手群里进行确认。{" "}
          </p>
          <p>
            3.
            由于本次比赛为线上直播形式，参赛队伍需要保证在比赛时段内网络通畅，随时可以准备进行比赛。请在报名前确认好你的时间；{" "}
          </p>
          <p>
            4.
            如果参赛队伍迟到五分钟及以上，或因未到、提前离开等原因未参赛，则认定该队失去参赛资格，判该队对手获胜；{" "}
          </p>
          <p>
            5. 参赛选手的 ID
            、头像、队伍名称、衣物、携带物品等不得含有违法国家法律法规的、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的文字、图案以及其他元素。如出现上述禁止情况，一经查证，则将取消该队伍参赛资格与比赛成绩；{" "}
          </p>
          <p>
            6.
            参赛选手不得发表违法国家法律法规、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的言论。如出现上述禁止情况，则取消该队伍参赛资格与比赛成绩；
          </p>
          <p>7. 本次比赛，机核网拥有最终解释权。 </p>
        </div>
      </Section>
      <Section title="服装和配色限制">
        <div className="tableRank">
          <table>
            <thead>
              <tr>
                <th>角色</th>
                <th>服装（配色）</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>巴洛克</td>
                <td>Gutsman</td>
              </tr>
              <tr>
                <td>布兰卡</td>
                <td>故事</td>
              </tr>

              <tr>
                <td>布兰卡</td>
                <td>Nergigante</td>
              </tr>

              <tr>
                <td>爱德</td>
                <td>Nero</td>
              </tr>

              <tr>
                <td>吉尔</td>
                <td>派朗</td>
              </tr>

              <tr>
                <td>拜森</td>
                <td>Astaroth</td>
              </tr>

              <tr>
                <td>内卡利</td>
                <td>万圣节</td>
              </tr>

              <tr>
                <td>彩虹美华</td>
                <td>职业</td>
              </tr>

              <tr>
                <td>拉希德</td>
                <td>Airman</td>
              </tr>

              <tr>
                <td>拉希德</td>
                <td>Viewtiful Joe</td>
              </tr>

              <tr>
                <td>隆</td>
                <td>Mega Man</td>
              </tr>

              <tr>
                <td>尤里安</td>
                <td>万圣节</td>
              </tr>

              <tr>
                <td>尤里安</td>
                <td>Wesker</td>
              </tr>

              <tr>
                <td>桑吉尔夫</td>
                <td>Mech（02）</td>
              </tr>

              <tr>
                <td>阿比盖尔</td>
                <td>万圣节（02）</td>
              </tr>

              <tr>
                <td>尤里安</td>
                <td>故事（06）</td>
              </tr>

              <tr>
                <td>尤里安</td>
                <td>战斗服1（07）</td>
              </tr>

              <tr>
                <td>吉尔</td>
                <td>战斗服1（11）</td>
              </tr>

              <tr>
                <td>吉尔</td>
                <td>战斗服1（15）</td>
              </tr>

              <tr>
                <td>所有角色</td>
                <td>默认（EX9）</td>
              </tr>

              <tr>
                <td>所有角色</td>
                <td>默认（EX10）</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>
      {/* <Bottom /> */}
    </>
  )
}

export default Zh
